// API client for the storage control plane (PG -> ClickHouse week migration).
const API_BASE = import.meta.env?.VITE_API_URL ?? "/api";

const buildApiUrl = (path) => {
  const base = API_BASE.endsWith("/") ? API_BASE.slice(0, -1) : API_BASE;
  return `${base}${path.startsWith("/") ? path : `/${path}`}`;
};

const authHeaders = () => {
  const token =
    typeof window === "undefined"
      ? null
      : window.localStorage.getItem("auth_token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const fetchStorageStatus = async () => {
  const res = await fetch(buildApiUrl("/infra/storage/status"), {
    headers: { ...authHeaders() },
  });
  if (!res.ok) throw new Error(`Failed to load storage status (${res.status})`);
  return res.json();
};

export const migrateWeek = async (from, to) => {
  const res = await fetch(buildApiUrl("/infra/storage/migrate-week"), {
    method: "POST",
    headers: { "content-type": "application/json", ...authHeaders() },
    body: JSON.stringify({ from, to }),
  });
  if (!res.ok) {
    const text = await res.text().catch(() => "");
    throw new Error(text || `Migration failed (${res.status})`);
  }
  return res.json();
};
